const commandCenterPageStyles = {
  formActions: {
    alignItems: "center",
    flexWrap: "wrap",
    gap: "1rem",
    justifyContent: "space-between",
  },
  statusLine: {
    alignItems: "center",
    flexWrap: "wrap",
    gap: "0.5rem",
  },
  descriptionBlock: {
    color: "text.secondary",
  },
  historyItem: {
    borderRadius: "4px",
    gap: "1rem",
  },
  historyItemText: {
    margin: 0,
  },
  outputWindow: {
    backgroundColor: "grey.900",
    borderRadius: "4px",
    color: "common.white",
    fontFamily: "monospace",
    margin: 0,
    maxHeight: "32rem",
    minHeight: "16rem",
    overflow: "auto",
    padding: "1rem",
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
  },
};

export default commandCenterPageStyles;
